<template>

	<ul class="feature-list">
		<li v-for="(feature, key, index) in features" :key="key">
			<dl class="columns is-mobile is-vcentered">
				<dt v-text="feature.label" class="column"></dt>
				<dd class="column is-narrow has-text-weight-bold">
					<p v-if="feature.type === 'numerical'" v-text="formatNumericalFeature(feature, key)"></p>
					<p v-else-if="feature.type === 'boolean'" v-text="formatBooleanFeature(feature, key)"></p>
					<div v-else class="tick-container">
						<transition name="feature-list-tick" mode="out-in">
							<img v-if="isFeatureIncluded(feature, key)" key="yes" src="/images/pricing/tick-green.svg" alt="Included" :class="`is-delayed-${Math.abs(numberOfPreviouslyIncludedFeatures - index)}`" />
							<img v-else key="no" src="/images/pricing/cross.svg" alt="Not included" :class="`is-delayed-${index - numberOfPreviouslyIncludedFeatures}`" />
						</transition>
					</div>
				</dd>
			</dl>
		</li>
	</ul>

</template>

<script>

export default {
	name: 'features',

	data() {
		return {
			numberOfPreviouslyIncludedFeatures: 0,
		};
	},

	computed: {
		data() {
			return this.$store.data[this.product] || {};
		},

		/* Select and format current list of features */
		features() {
			if (this.data.features) {
				return this.data.features;
			} else {
				return this.selectedProduct.features.map(feature => {
					return {
						type: "tick",
						label: feature,
					};
				});
			}
		},

		/* Object of the currently selected tier */
		selectedProduct() {
			return this.data.products[this.selectedTier] || {};
		},

		/* Return the number of features included in the currently selected tier */
		numberOfIncludedFeatures() {
			if (this.selectedTier === '') {
				return 0;
			} else {
				return Object.keys(this.selectedProduct.features).length;
			}
		},
	},

	methods: {
		/* Whether or not the given feature is included in the selected tier */
		isFeatureIncluded(feature, key) {
			if (this.selectedTier === '') {
				return false;
			} else {
				return Boolean(this.selectedProduct.features[key]);
			}
		},

		/* Format a numerical tier feature value */
		formatNumericalFeature(feature, key) {
			if (this.selectedTier === '') {
				return '-';
			} else {
				const currentValue = this.selectedProduct.features[key];
				
				if (currentValue < 0) {
					return feature.unlimitedLabel || 'Unlimited';
				} else {
					return ('unit' in feature) ? `${currentValue} ${feature.unit}` : currentValue;
				}
			}
		},

		/* Format a boolean tier feature value */
		formatBooleanFeature(feature, key) {
			if (this.selectedTier === '') {
				return '-';
			} else {
				const currentValue = this.selectedProduct.features[key];

				if (currentValue === true) {
					return ('value' in feature) ? feature.value : 'Yes';
				} else {
					return '-';
				}
			}
		},
	},

	watch: {
		numberOfIncludedFeatures(newCount, oldCount) {
			this.numberOfPreviouslyIncludedFeatures = oldCount;
		},
	},

	props: {
		/* Product name */
		/* [ compare, automation, addons, backup ] */
		product: {
			required: true,
		},
		
		selectedTier: String,
	},
};

</script>

<style lang="scss" scoped>
@import '@gearset/web-core/styles/includes/variables';

.feature-list {
	.columns {
		margin-top: -.75rem;
		margin-bottom: -.75rem;
	}

	.column {
		padding-top: .75rem;
		padding-bottom: .75rem;
	}

	.tick-container {
		position: relative;
		width: 21px;
		height: 21px;
	}

	img {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		width: 21px;
		height: 21px;

		&.is-included {
			z-index: 2;
		}

		@for $i from 0 to 16 {
			&.is-delayed-#{$i} {
				animation-delay: $i * .015s;
			}
		}
	}
}

.feature-list-tick-enter-active {
	animation: .4s calculator-features-pop both;
}

.feature-list-tick-leave-active {
	animation: .25s calculator-features-pop both reverse;
}

@keyframes calculator-features-pop {
	0% {
		transform: scale(0);
	}

	20% {
		transform: scale(1.125);
	}

	100% {
		transform: scale(1);
	}
}

</style>
